const usTimezones = [
    "America/New_York",      // 东部时区
    "America/Chicago",       // 中部时区
    "America/Denver",        // 山地时区
    "America/Phoenix",      // 山地时区（亚利桑那州，不实行夏令时）
    "America/Los_Angeles",  // 太平洋时区
    "America/Anchorage",    // 阿拉斯加时区
    "America/Adak",         // 阿拉斯加时区（阿留申群岛）
    "Pacific/Honolulu"      // 夏威夷时区
];

function isUSTimezone() {
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return usTimezones.includes(userTimezone);
}

function getVariantId() {
    // const urlParams = document.querySelectorAll('[name="id"]');

    // console.log(urlParams)
  
    // var values = urlParams.urlParams[urlParams.length - 2].getAttribute('value')
    // console.log('Variant id:', values);
  
    // if (urlParams) {
    //     sendHTTPRequest(values);
    // }

    const xpath = "//safe-sticky//div[@data-block-type='buy-buttons']//form//input[3]";

    const result = document.evaluate(
      xpath,                // XPath 表达式
      document,             // 上下文节点（从整个文档开始搜索）
      null,                 // 命名空间解析器（通常为 null）
      XPathResult.FIRST_ORDERED_NODE_TYPE, // 返回类型（返回第一个匹配的节点）
      null                  // 结果复用（通常为 null）
    );
    const inputElement = result.singleNodeValue;
    console.log(inputElement)
    if (inputElement) {
      // 获取 value 属性
      const value = inputElement.defaultValue;
      console.log("Value:", value);  
      
      sendHTTPRequest(value);
    } else {
      console.log("Element not found");
    }
}

async function sendHTTPRequest(variantId) {
    // 发送请求到后端，将 variantId 作为参数传递
    const response = await fetch(`https://api.ugeat.com?variantId=${variantId}`); //需要添加服务器地址
    const data = await response.json();
    console.log('request-data:', data);
    const existingInventoryQuantity = document.querySelector('.Inventory-quantity');
    if (existingInventoryQuantity) {
        // 若存在，则移除该元素
        existingInventoryQuantity.remove();
    }
    const targetElement = document.querySelector('[data-block-type="quantity-selector"]')
    // const nextSibling = targetElement.previousElementSibling;
    if (targetElement) {

        // 使用 window.matchMedia 检测屏幕宽度是否大于 750px
        const mediaQuery = window.matchMedia('(min-width: 750px)');
        // 定义一个函数来处理样式设置
        function setStyles() {
            if (mediaQuery.matches) {
                // 当屏幕宽度大于 750px 时设置样式
                targetElement.style.display = 'flex';
                targetElement.style.justifyContent = 'flex-start';
                targetElement.style.alignItems = "center";
            } else {
                // 当屏幕宽度小于等于 750px 时移除样式（可选）
                targetElement.style.display = '';
                targetElement.style.justifyContent = '';
                targetElement.style.alignItems = '';
            }
        }
        // 初始调用函数以设置初始样式
        setStyles();
        // 监听媒体查询的变化，当屏幕宽度改变时重新设置样式
        mediaQuery.addEventListener('change', setStyles);
        const newDiv = document.createElement("div");
        newDiv.classList.add("Inventory-quantity");
        const newSpan = document.createElement("span");
        const newI = document.createElement("i")
        if (data > 10) {
            newSpan.textContent = "Available in U.S. warehouse – ready to ship FREE!";
            newI.classList.add("safe");
        } else if (data >= 1) {
            // 创建一个新的 span 元素来包裹 data
            const dataSpan = document.createElement('span');
            dataSpan.textContent = data;
            dataSpan.style.color = '#e32c2b';
            dataSpan.style.fontWeight = "bold"

            // 拼接文本内容
            newSpan.appendChild(document.createTextNode('Only '));
            newSpan.appendChild(dataSpan);
            newSpan.appendChild(document.createTextNode('  left in U.S. warehouse – FREE & fast domestic shipping!'));
            newI.classList.add("danger");
        }
        newDiv.appendChild(newI);
        newDiv.appendChild(newSpan);
        targetElement.appendChild(newDiv);
    }
}

// 定义一个函数用于处理 variant 参数的变化
async function handleVariantChange() {
    if (!isUSTimezone()) {
        console.log('The user is not in the US and does not perform follow-up actions');
        return;
    }

    let variantValue = await getVariantId();
}
console.log("product is load")
// 页面加载完成后，先获取一次 variant 参数
handleVariantChange();
const xpath1 = "//safe-sticky//div[@data-block-type='variant-picker']";
const result1 = document.evaluate(
  xpath1,                // XPath 表达式
  document,             // 上下文节点（从整个文档开始搜索）
  null,                 // 命名空间解析器（通常为 null）
  XPathResult.FIRST_ORDERED_NODE_TYPE, // 返回类型（返回第一个匹配的节点）
  null                  // 结果复用（通常为 null）
);
const inputElement1 = result1.singleNodeValue;
console.log(inputElement1)
inputElement1.addEventListener("click",function(){
  setTimeout(()=>{
    handleVariantChange();
  }, 100)
})
